/**
 * A report's headers in this order, for showing a drag before the server has answered. A header the
 * list does not name goes last; the refetch that follows settles it.
 */
export function withSectionOrder<S extends { id: string; position: number }>(
  sections: readonly S[],
  order: readonly string[],
): S[] {
  const rank = new Map(order.map((id, index) => [id, index]))
  return sections
    .toSorted((a, b) => (rank.get(a.id) ?? order.length) - (rank.get(b.id) ?? order.length))
    .map((section, position) => ({ ...section, position }))
}
